export default "__VITE_ASSET__6pMJk5D6__"